import React, { useEffect, useRef, useState } from 'react';
import { Search, ChevronDown, ChevronRight, X } from 'lucide-react';
import { Link, useNavigate } from 'react-router-dom';
import { Get_Api } from '../../API_URL';
import { toast } from 'react-toastify';

const jobs = [
    {
        id: 1,
        title: "Business Analyst – Payments Domain",
        experience: "10 Years",
        location: "Pune (Hybrid work Mode) India",
        link: "/apply/1",
    },
    {
        id: 2,
        title: "Java Full Stack Developer",
        experience: "5-8 Years",
        location: "Bangalore (Remote) India",
        link: "/apply/2",
    },
    {
        id: 3,
        title: "UI/UX Designer",
        experience: "3-5 Years",
        location: "Mumbai (On-site) India",
        link: "/apply/3",
    },
    {
        id: 4,
        title: "DevOps Engineer",
        experience: "6+ Years",
        location: "Hyderabad (Hybrid) India",
        link: "/apply/4",
    },
];

const ExploreOpenRoles = () => {
    const [activeDropdown, setActiveDropdown] = useState(null);

    const dropdownRef = useRef(null);

    const navigate = useNavigate()
    const [Alljobs, setAlljobs] = useState([]);
    const [Isloading, setIsloading] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");

    const GetAlljobs = async () => {
        try {
            setIsloading(true)
            const response = await Get_Api("api/admin/GetAllJobs");
            setAlljobs(response?.data || [])
            setIsloading(false)
        } catch (error) {
            setIsloading(false)
            toast.error(error?.response?.message || "Failed to upload requirement");
            console.error("Error uploading requirement:", error);
        }
    }

    useEffect(() => {
        GetAlljobs();
    }, []);

    const filteredJobs = Alljobs?.filter((job) =>
        job?.Title?.toLowerCase().includes(searchTerm?.toLowerCase())
    );

    const Loader = () => {
        return (
            <div className="flex items-center justify-center py-10 h-[400px]">
                <div className="w-10 h-10 border-4 border-[#01386A] border-t-transparent rounded-full animate-spin"></div>
            </div>
        );
    };



    const filters = [
        {
            label: 'Job Location',
            options: ['Pune (Hybrid)', 'Bangalore (Remote)', 'Mumbai (On-site)', 'Hyderabad (Hybrid)', 'Delhi NCR']
        },
        {
            label: 'Job Type',
            options: ['Full Time', 'Part Time', 'Contract', 'Internship']
        },
        {
            label: 'Job Workspace',
            options: ['On-site', 'Remote', 'Hybrid']
        },
        {
            label: 'Employment Type',
            options: ['Permanent', 'Freelance', 'Temporary']
        }
    ];

    const toggleDropdown = (index) => {
        if (activeDropdown === index) {
            setActiveDropdown(null);
        } else {
            setActiveDropdown(index);
        }
    };


    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setActiveDropdown(null);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    return (
        <section className="w-full pb-16 lg:pb-24 bg-white font-sans">
            <div className="max-w-[1440px] mx-auto px-6 md:px-[80px]">
                <h2 className="text-[20px] md:text-[30px] font-[600] text-[#01386A] font-sora mb-8">
                    Explore Open Roles
                </h2>
                <div className="mb-12">

                    <div className="flex flex-col md:flex-row gap-4 mb-6">
                        <div className="relative flex-1">
                            <Search className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400" size={20} />
                            <input
                                type="text"
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                                placeholder="Search By Job Or Title"
                                className="w-full h-[56px] pl-12 pr-4 border border-gray-300 focus:outline-none focus:border-[#0E2A62]"
                            />
                        </div>
                        <button className="h-[56px] font-graphik lg:text-[16px] text-[14px] font-[500] px-8 bg-white border border-[#F06115] text-[#F06115] flex items-center gap-2 hover:bg-[#F06115] hover:text-white transition-all duration-300">
                            Search <ChevronRight size={18} />
                        </button>
                    </div>

                    {/* <div className="border border-gray-200 p-6 rounded-sm">
                        <div className="flex justify-between items-center mb-4">
                            <h4 className="text-[#000000] font-[600] font-graphik text-[20px] leading-[22px]">Filter results</h4>
                            <button className="text-[#F06115] text-sm font-semibold flex items-center gap-1 hover:underline">
                                Clear <ChevronRight size={14} />
                            </button>
                        </div>
                        <div ref={dropdownRef} className="grid grid-cols-1 md:grid-cols-4 gap-6">
                            {filters.map((filter, index) => (
                                <div
                                    key={index}
                                    className="relative group cursor-pointer border-b border-gray-300 pb-2"
                                >   <div
                                        className="flex justify-between items-center text-gray-500 hover:text-[#0E2A62] transition-colors"
                                        onClick={() => toggleDropdown(index)}
                                    >
                                        <span className="text-sm font-medium">{filter.label}</span>
                                        <ChevronDown
                                            size={16}
                                            className={`transition-transform duration-300 ${activeDropdown === index ? 'rotate-180 text-[#0E2A62]' : ''}`}
                                        />
                                    </div>
                                    {activeDropdown === index && (
                                        <div className="absolute top-full left-0 w-full bg-white shadow-xl z-50 border border-gray-100 mt-1 rounded-sm py-2 animate-in fade-in zoom-in-95 duration-200">
                                            {filter.options.map((option, optIndex) => (
                                                <div
                                                    key={optIndex}
                                                    className="px-4 py-2 text-sm text-[#49577A] hover:bg-[#F8F9FC] hover:text-[#0E2A62] hover:font-medium transition-colors"
                                                    onClick={() => {
                                                        console.log(`Selected: ${option}`);
                                                        setActiveDropdown(null); 
                                                    }}
                                                >
                                                    {option}
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            ))}
                        </div>
                    </div> */}

                </div>

                {/* --- JOB LIST --- */}
                <div className="space-y-6">
                    <h3 className="text-[20px] md:text-[30px] font-[600] text-[#01386A] font-sora mb-6">All Job</h3>
                    {
                        Isloading ?
                            <Loader />
                            :
                            <div className="flex flex-col gap-6">
                                {filteredJobs?.length > 0 ? (
                                    filteredJobs.map((job) => (
                                        <div
                                            key={job?._id}
                                            className="group relative bg-white border-t border-x border-[#D5D5D5] p-[20px] md:p-[36px] transition-all duration-300 hover:shadow-xl"
                                        >
                                            <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-6">
                                                <div className="flex-1">
                                                    <h3 className="text-[#01386A] text-[16px] md:text-[20px] font-[600] font-sora mb-4 group-hover:text-[#F06115] transition-colors duration-300">
                                                        {job?.Title}
                                                    </h3>

                                                    <div className="flex flex-col md:flex-row font-sora md:items-center gap-2 md:gap-4 text-[#49577A] text-[14px] md:text-[16px] font-[600]">
                                                        <p>Experience: <span className="font-[500] font-graphik">{job?.Experience} + years</span></p>
                                                        <span className="hidden md:block text-gray-300">|</span>
                                                        <p>Location: <span className="font-[500] font-graphik">{job?.Location?.City} {job?.Location?.Country}</span></p>
                                                    </div>
                                                </div>
                                                <div className="flex flex-col md:flex-row items-center gap-6 w-full md:w-auto">
                                                    {/* <Link to={`/careers-apply/${job?._id}`} className="text-[#0E2A62] font-semibold text-sm flex items-center gap-1 hover:gap-2 transition-all">
                                                        View Jobs <ChevronRight size={16} />
                                                    </Link> */}

                                                    <Link
                                                        to={`/careers-apply/${job?._id}`}
                                                        className="px-8 py-3 border border-[#F06115] text-[#F06115] font-[500] lg:text-[16px] text-[14px] font-graphik flex items-center justify-center gap-2 hover:bg-[#F06115] hover:text-white transition-all duration-300 w-full md:w-auto"
                                                    >
                                                        Apply Now <ChevronRight size={18} />
                                                    </Link>
                                                </div>

                                            </div>
                                            <div className="absolute bottom-0 left-0 w-full h-[3px] bg-[#0E2A62]" />
                                            <div className="absolute bottom-0 left-0 w-0 h-[3px] bg-[#F06115] transition-all duration-500 ease-out group-hover:w-full" />
                                        </div>
                                    ))
                                ) : (
                                    <div className="text-center py-16 border border-dashed border-gray-300 bg-gray-50">
                                        <h3 className="text-xl font-semibold text-[#01386A] mb-2">
                                            No Jobs Found
                                        </h3>
                                        <p className="text-gray-500">
                                            Try searching with a different keyword.
                                        </p>
                                    </div>
                                )}
                            </div>
                    }
                </div>
            </div>
        </section>
    );
};

export default ExploreOpenRoles;